export const isNil = (x: unknown): boolean => x === undefined || x === null;
